
  import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import { AdminAracEkleOptions } from "../../../utils/adminAracEkleOptions"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputNewAracTypeSelect from "../../shared/input/new/InputNewAracTypeSelect"
import { updateRentalCar } from "../../../features/ilanlar/ilanlarSlice"

import InputCaseTypeSelect from "../../shared/input/new/InputCaseTypeSelect"
import InputSelect from "../../shared/input/new/InputSelect"
import InputText from "../../shared/input/new/InputText"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"
import InputDate from "../../shared/input/new/InputDate"
import InputNumberWithSuffix from "../../shared/input/new/InputNumberWithSuffix"
import InputTextarea from "../../shared/input/new/InputTextarea"
import { getAracTypes } from "../../../features/adminSett/adminSettSlice"
import locationCityList from "../../../utils/locationData/locationCityOptions"
import InputSelectCityMultiple from "../../shared/input/new/InputSelectCityMulti"

const Container = styled.div`
     position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 800px;
        height: 700px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        padding-top: 20px;
        align-items: center;
        overflow: auto;
        position: relative;
        .content{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .inputs{
                display: flex;
                flex-direction: column;
                gap: 15px;
                width: 70%;
                margin-top: 30px;
                padding-inline: 30px;
                .row{
                    width: 100%;
                }
            }

            .btn-group{
                display: flex;
                align-items: center;
                margin-top: 20px;
                position: sticky;
                bottom: 0;
                justify-content: center;
                background-color: white;
                gap: 15px;
                width: 100%;
                z-index: 10;
                height: 60px;
            }
        }
        
    }

`
const advertData = [
    {
        id:1,
        text:"Yayında"
    },
    {
        id:2,
        text:"Arşivde"
    }
]

const withDriverData = [
    {
        id:1,
        text:"Sürücülü",
        bool: true
    },
    {
        id:2,
        text:"Sürücüsüz",
        bool: false
    }
]
    
const AdvertRentalCarUpdateModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const {selectRentalCar } = useSelector(state => state.ilanlar)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    const {aracTypes} = useSelector((state)=> state.adminSett)

    useEffect(()=>{
        dispatch(getAracTypes())
    },[dispatch])
    

    const [selectedTruckType, setSelectedTruckType] = useState(aracTypes?.find(item => item.name === selectRentalCar?.vehicleType))
    const [initialCaseType, setInitialCaseType] = useState(aracTypes?.find(item => item.name === selectRentalCar?.vehicleType)?.trailerTypesModel?.$values)
    const [selectedCaseType, setSelectedCaseType] = useState(initialCaseType?.find(item => item?.name === selectRentalCar?.bodyType))
    const [isWithDriver, setIsWithDriver] = useState(withDriverData?.find(item => item.bool === selectRentalCar?.withDriverOrWithoutDriver))
    const [selectedCity, setSelectedCity] = useState([])
    const [phoneToCall, setPhoneToCall] = useState(selectRentalCar?.contactNumber)
    const [advertiserMemberPhone, setAdvertiserMemberPhone] = useState(selectRentalCar?.advertiserPhoneNumber)

    const [data, setData] = useState({
        workRoute: selectRentalCar?.workRoute,
        fuelPercentage: selectRentalCar?.fuelPercentage,
        rentalPrice: selectRentalCar?.rentalPrice,
        advertRegistrationDate: selectRentalCar?.advertRegistrationDate,
        description: "",
        advertEndDate: selectRentalCar?.advertEndDate.split("T")[0],
        title: selectRentalCar?.title
    })

    useEffect(() => {
        if (locationCityList.length > 0) {
          const filteredCities = locationCityList.filter(city =>
            selectRentalCar.truckVehicleWorkCities.$values.some(data => data.cityId === parseInt(city.cityId))
          );
            setSelectedCity(filteredCities);
        }
    }, [selectRentalCar, locationCityList]);

    useEffect(() => {
        if (phoneToCall) {
            const formattedPhoneNumber = (phoneToCall.startsWith("+90") || phoneToCall.startsWith("90")) ? `${phoneToCall}` : `90${phoneToCall}`;
            setPhoneToCall(formattedPhoneNumber);
        }
    }, []);
    useEffect(() => {
        if (advertiserMemberPhone) {
            const formattedPhoneNumber = (advertiserMemberPhone.startsWith("+90") || advertiserMemberPhone.startsWith("90")) ? `${advertiserMemberPhone}` : `90${advertiserMemberPhone}`;
            setAdvertiserMemberPhone(formattedPhoneNumber);
        }
    }, []);

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const stringToNum = (item) => {
        const numericString = item.replace(/\D/g, "");
        const intValue = parseInt(numericString);
        return intValue
    }

    const handleSubmit = () => {
        const addData = {
            id: selectRentalCar?.id,
            vehicleType: selectedTruckType?.name,
            bodyType: selectedCaseType?.name || "", 
            withDriverOrWithoutDriver: isWithDriver?.bool,
            rentVehicleNewWorkCities: selectedCity.map((item) => {return({ cityId: parseInt(item?.cityId), city: item?.city })}),
            workRoute: data?.workRoute,
            fuelPercentage:  (typeof data?.fuelPercentage) === "number" ? data?.fuelPercentage : stringToNum(data?.fuelPercentage),
            rentalPrice: (typeof data?.rentalPrice) === "number" ? data?.rentalPrice : stringToNum(data?.rentalPrice),
            contactNumber: phoneToCall?.startsWith("+90") ? phoneToCall?.slice(2) : phoneToCall,
            advertEndDate: data?.advertEndDate,
            title: data?.title,
        }
        
        dispatch(updateRentalCar(addData))
    }

    const handleChange = (e) => {
        setData((prev) => ({...prev, [e.target.name]: e.target.value}))
    }

  return (
    <Container onClick={() => dispatch(showModal(null)) }>
        <div className="modal" onClick={(e)=>{e.stopPropagation(); dispatch(handleActiveSelect(null))}} >
            <PageTopTitle isDiffPage title={"İlan Güncelle"}/>

            <div className="content">
                <div className="inputs">
                    <div className="row">
                        <InputText data={data?.title} setData={(e) => handleChange(e)} name={"title"} labelText={"İlan Başlığı"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNewAracTypeSelect setInitialCaseType={setInitialCaseType} data={selectedTruckType} setData={setSelectedTruckType} labelText={"Araç Tipi"} name={"selectedTruckType"} initialOptions={AdminAracEkleOptions} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputCaseTypeSelect initialOptions={initialCaseType} data={selectedCaseType} setData={setSelectedCaseType} labelText={"Kasa Tipi"} name={"selectedCaseType"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputSelect data={isWithDriver?.text} setData={setIsWithDriver} initialOptions={withDriverData} name={"isWithDriver"} labelText={"Sürücülü / Sürücüsüz"} inputWidth={"100%"} />
                    </div>
                    {/* <div className="row">
                        <InputSelectCity data={selectedCity?.value} setData={setSelectedCity} name={"selectedCity"} labelText={"Çalışılmak İstenilen İl"} inputWidth={"100%"} />
                    </div> */}
                    <div className="row">
                        <InputSelectCityMultiple data={selectedCity} setData={setSelectedCity} labelText={"Çalışacak İl / İller"} initialOptions={locationCityList} inputWidth={"100%"} name={"iller"}/>
                    </div>
                    <div className="row">
                        <InputText data={data?.workRoute} setData={(e) => handleChange(e)} name={"workRoute"} labelText={"Çalışılmak İstenilen Güzergah"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberWithSuffix suffix={" %"} noneSeperator data={data?.fuelPercentage} setData={(e) => handleChange(e)} name={"fuelPercentage"} labelText={"Talep Edilen Yakıt Yüzdesi"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputNumberWithSuffix suffix={" TL"} data={data?.rentalPrice} setData={(e) => handleChange(e)} name={"rentalPrice"} labelText={"Talep Edilen Aylık Kira Bedeli (KDV Hariç)"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputTextarea data={data?.description} setData={(e) => handleChange(e)} name={"description"} labelText={"Açıklama"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputPhoneFormat data={phoneToCall} setData={setPhoneToCall} name={"phoneToCall"} labelText={"İlan için Aranacak telefon"} inputWidth={"100%"} />
                    </div>
                    <div className="row">
                        <InputDate data={data?.advertEndDate} setData={(e) => handleChange(e)} labelText={"İlan Bitiş Tarihi"} name={"advertEndDate"} inputWidth={"100%"} />
                    </div>
                    
                </div>
                <div className="btn-group">
                    <Button width="150px" handleClick={handleSubmit} padding="10px" background="#fff" color={"#E85446"}>Güncelle</Button>
                    <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" background="#fff" color={"#E85446"}>Kapat</Button>
                </div>
            </div>
        </div>
    </Container>
  )
}

export default AdvertRentalCarUpdateModal